<div class="container-fluid">
  <div class="row mx-2">
    <h1 class="col-12 fw-700 mt-3">Privacy Policy</h1>
    <p class="col-12 fw-700 my-2">
      <strong>Effective Date: April 15, 2026</strong>
    </p>
    <p class="col-12 my-3 text-justify">
      This Privacy Policy describes what personal information we collect through
      our web and mobile apps ("Platform"), how we collect the information, and
      for what purpose. By using or accessing our Platform, including any
      embedded applications made available on third-party sites, you are
      consenting to the practices described in this Privacy Policy.
    </p>
  </div>
  <hr />
  <div class="row mx-2 terms-list-style list">
    <div class="col-12">
      <h5 class="fw-700 mt-3">1. INFORMATION WE COLLECT</h5>
      <ul style="list-style-type: disc !important; padding-left: 1.5rem">
        <li class="my-2">
          <strong>Information Provided By You:</strong> We collect and store
          personal information you provide when you fill out a form, register or
          create an account on our Platform, including your name, email address,
          <strong>phone number</strong>, and any other personal information you
          choose to share.
        </li>
        <li class="my-2">
          <strong>Information Collected Automatically:</strong> When you access
          our Platform, we may automatically collect and store information about
          your device such as your IP address, device type, geographic location
          data, and unique device identifier.
        </li>
        <li class="my-2">
          <strong>Cookies and Tracking:</strong> We use cookies to recognize
          you, understand your preferences, and improve your user experience.
          You can set your browser to refuse cookies, though some features of
          the Platform may not function properly as a result.
        </li>
      </ul>
      <hr />
      <h5 class="fw-700 mt-3">2. HOW WE USE THE INFORMATION WE COLLECT</h5>
      <p class="mt-2 text-justify">We use the information to:</p>
      <ul style="list-style-type: disc !important; padding-left: 1.5rem">
        <li class="my-2">Communicate and respond to your inquiries.</li>
        <li class="my-2">Verify your identity via SMS/Text verification.</li>
        <li class="my-2">
          Improve user experience and maintain internal records.
        </li>
        <li class="my-2">
          Send you notices (via email or SMS) regarding services, companies, and
          events that might interest you.
        </li>
      </ul>
      <hr />
      <h5 class="fw-700 mt-3">
        3. THIRD PARTIES WITH WHOM WE SHARE YOUR INFORMATION
      </h5>
      <p class="mt-2 text-justify">
        We may share information with the following parties:
      </p>
      <ul style="list-style-type: disc !important; padding-left: 1.5rem">
        <li class="my-2">
          <strong>Service Providers:</strong> Third-party partners who help
          operate our Platform (e.g., hosting, email services, and analytics).
        </li>
        <li class="my-2">
          <strong>Event Hosts:</strong> If you explicitly opt-in when joining a
          virtual event, we may share your contact information with the
          <strong>Host or Organizer</strong> of that specific event for their
          outreach.
        </li>
        <li class="my-2">
          <strong>Legal Requirements:</strong> As required by law or to protect
          the safety and rights of CitizeX and its users.
        </li>
      </ul>
      <hr />
      <h5 class="fw-700 mt-3">
        4. SMS AND MOBILE MESSAGING (10DLC COMPLIANCE)
      </h5>
      <p class="mt-2 text-justify">
        CitizeX values your privacy regarding mobile communication.
        <strong>Please note the following:</strong>
      </p>
      <ul style="list-style-type: disc !important; padding-left: 1.5rem">
        <li class="my-2">
          <strong>No Sharing of SMS Data:</strong> No mobile information will be
          shared with third parties or affiliates for marketing or promotional
          purposes. All the above categories of sharing exclude text messaging
          originator opt-in data and consent; this information will not be
          shared with any third parties.
        </li>
        <li class="my-2">
          <strong>Opt-In:</strong> By providing your phone number and checking
          the consent box, you agree to receive one-time verification codes.
          Consent is not a condition of purchase or a requirement to use the
          platform.
        </li>
        <li class="my-2">
          <strong>Opt-Out:</strong> You may opt out of SMS communications at any
          time by replying <strong>STOP</strong> to any message received. For
          support, reply <strong>HELP</strong>.
        </li>
        <li class="my-2">
          <strong>Rates:</strong> Message and data rates may apply. Message
          frequency varies.
        </li>
      </ul>
      <hr />
      <h5 class="fw-700 mt-3">5. RIGHT TO OPT-IN AND OPT-OUT</h5>
      <p class="mt-2 text-justify">
        You have the right to "opt in" and "opt out" of certain uses of your
        personal information. You may opt out of any email communication by
        clicking the "unsubscribe" link or by contacting us at
        <strong>info&#64;citizex.ai</strong>.
      </p>
      <hr />
      <h5 class="fw-700 mt-3">6. DATA SECURITY</h5>
      <p class="mt-2 text-justify">
        We implement reasonable technical and organizational measures to protect
        your personal information. However, no security system is perfect. Do
        not send sensitive information (such as passwords or SSNs) via insecure
        email or "contact us" forms.
      </p>
      <hr />
      <h5 class="fw-700 mt-3">7. CHILDREN</h5>
      <p class="mt-2 text-justify">
        Our Platform is not intended for or directed at children under the age
        of 16. We do not knowingly collect personal information from children
        under 16.
      </p>
      <hr />
      <h5 class="fw-700 mt-3">8. CONTACT US</h5>
      <p class="mt-2 text-justify">
        If you have any questions regarding this Privacy Policy, please contact
        us at: <strong>Email:</strong> info&#64;citizex.ai
      </p>
      <hr />
      <h5 class="fw-700 mt-3">9. PRIVACY POLICY UPDATES</h5>
      <p class="mt-2 text-justify mb-5">
        We may update this Privacy Policy to reflect changes to our practices.
        If we make material changes, we will post the amended version on the
        Platform.
      </p>
    </div>
  </div>
</div>
